<template>
  <transition name="modal"
    @after-enter="opened = true"
    @leave="opened = false"
  >
    <div
      v-if="visible"
      ref="modal"
      class="modal"
      :class="{ scrollable: scrollable }"
    >
      <div
        class="modal-content"
        ref="content"
        v-click-outside="closeByOutside"
      >
        <slot />
        <div class="close-button" @click.stop="close">
          <f-sprite-icon :icon-link="$options.icons.IconClose.id" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import IconClose from '../../../assets/icons/close.svg';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
  name: 'Modal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    scrollable: {
      type: Boolean,
      default: false,
    },

    backgroundMode: { // отключает блокировку bodyScroll и click-outside(можно открыть фоном)
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    opened: false, // состояние после открытия (кейс с самозакрытием на click-outside)
  }),

  icons: {
    IconClose
  },

  watch: {
    visible() {
        this.visible
          ? this.$nextTick(this.onOpen)
          : this.onClose();
    }
  },

  methods: {
    onOpen() {
      document.body.classList.add('modal-opened');
      !this.backgroundMode && disableBodyScroll(this.$refs.content);
    },

    onClose() {
      document.body.classList.remove('modal-opened');
      !this.backgroundMode && enableBodyScroll(this.$refs.content);
    },

    close(e) {
      this.opened && this.$emit('on-close', e);
    },

    closeByOutside(e) {
      if (e.target !== this.$refs.modal) return; // фикс исправляющий неожиданное закрытие модалок
      // при их наложении друг на друга
      !this.backgroundMode && this.close();
    }
  },

};
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background: rgba(0, 0, 0, .5);
  overflow: hidden;
  z-index: 99;

  &-content {
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 24px;
    background-color: $white;
    border-radius: 4px 4px 0 0;
    max-height: 96%;
    overflow-y: auto;
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 14px;
    width: 48px;
    height: 48px;
    color: $gray_lu;
    cursor: pointer;
  }

  // transition
  &-enter-active,
  &-leave-active {
    transition: opacity .2s;
    .modal-content {
      transition: transform .26s;
    }
  }
  &-enter,
  &-leave-active {
    opacity: 0;
    .modal-content {
      transform: translateY(100px);
    }
  }
}

@include breakpoint("tablet") {
  .modal {
    align-items: center;
    &.scrollable {
      overflow: auto;
      justify-content: flex-start;
    }
    &-content {
      bottom: auto;
      width: initial;
      border-radius: 4px;
      max-height: none;
    }
    // transition
    &-enter-active,
    &-leave-active {
      transition: opacity .2s;
      .modal-content {
        transition: transform .15s;
      }
    }
    &-enter,
    &-leave-active {
      opacity: 0;
      .modal-content {
        transform: scale(.94);
      }
    }
  }
}
</style>
